import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';
import { DataRoomDetail, PatchDataRoomDto } from './space.types';
import { SPACE_INVALIDATION_KEYS } from './space-invalidation.const';

type PatchDataRoomVariables = { id: string } & PatchDataRoomDto;

export const usePatchDataRoom = () => {
  const { invalidateQuery } = useInvalidateQueries(
    ...SPACE_INVALIDATION_KEYS,
    QueryKey.DATA_ROOM_ACCESS,
  );

  const {
    isPending,
    mutate: patchDataRoom,
    mutateAsync: patchDataRoomAsync,
  } = useAppMutation<DataRoomDetail, unknown, PatchDataRoomVariables>([QueryKey.PATCH_DATA_ROOM], {
    mutationFn: ({ id, ...body }) =>
      ApiService.patch({ endpoint: BackendRoute.DATA_ROOMS, routePath: [id] }, { body }),
    onSuccess: () => {
      invalidateQuery();
    },
  });

  return { isPending, patchDataRoom, patchDataRoomAsync };
};
